import { render } from "./Pledge.vue?vue&type=template&id=e9fdfe94&scoped=true"
import script from "./Pledge.vue?vue&type=script&lang=js"
export * from "./Pledge.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fdfe94"]])

export default __exports__